import React from 'react';
import styles from './OwnNumberNote.module.css';

// Nota de rodapé do asterisco usada na landing: o envio sozinho (automático) de
// mensagens só existe com o módulo do número próprio de WhatsApp. Sem ele, o app
// monta a mensagem pronta e abre o WhatsApp Web para a pessoa enviar em um clique.
// Decisão de produto 2026-10-23. Uma nota por seção, sempre com o mesmo texto.
export const OWN_NUMBER_NOTE = '* Necessário o módulo com o seu número próprio.';

function OwnNumberNote({ className = '' }) {
  return (
    <p className={`${styles.note} ${className}`.trim()}>
      {OWN_NUMBER_NOTE}
    </p>
  );
}

export default OwnNumberNote;
